/**
 * 工具站呼叫後端 API 的 base URL
 * 建置時請設定 VITE_API_BASE；本地開發未設定時 fallback 至 http://localhost:8787（讓 Super Admin 的「工具站顯示」約束可生效）
 */
export const getApiBase = (): string => {
  const env = (import.meta.env.VITE_API_BASE as string) ?? '';
  if (env.trim() !== '') return env.trim();
  if (import.meta.env.DEV) return 'http://localhost:8787';
  return '';
};
